import Vue from 'vue';

import './plugins/index';
import { router, store } from './plugins/modules/vueRouter';
import vuetify from './plugins/modules/vuetify';

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$cdnPath = process.env.VUE_APP_CDN_PATH;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(require('./App').default)
}).$mount('#app');
